export default '/build/7ad26e26.svg'